module.exports = "/3/3-tu-khoa-break-va-continue/index.html.c983e54dd6ea453335d29abe8ca349ef.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30014.md
 ** module id = 546
 ** module chunks = 0
 **/